import {
  getMediaFor,
  MEDIA_BREAKPOINT_KEYS,
} from "style/style_snippets"
import React from "react"
import { Typography } from "@mui/material"

const HomeParagraph = ({ title, description }) => {
  const paragraphStyle = {
    title: {
      ...getMediaFor("marginBottom", "18px", {
        [MEDIA_BREAKPOINT_KEYS.xs]: "20px",
        [MEDIA_BREAKPOINT_KEYS.sm]: "22px",
      }),
    },
    description: {
      ":not(:last-of-type)": {
        ...getMediaFor("marginBottom", "30px", {
          [MEDIA_BREAKPOINT_KEYS.xs]: "35px",
          [MEDIA_BREAKPOINT_KEYS.sm]: "50px",
        }),
      },
    },
  }
  return (
    <>
      <Typography css={paragraphStyle.title} variant={"h3"}>
        {title}
      </Typography>
      <Typography variant={"body1"} css={paragraphStyle.description}>
        {description}
      </Typography>
    </>
  )
}
export default HomeParagraph
